import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth.js';

export const ProtectedRoute = ({ children, requiredRoles }) => {
  const { user, token } = useAuth();

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && !requiredRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};
